import { StyledModal } from '@app/components/modal/Modal';
import useLocationActions from '@app/hooks/locations/useLocationActions';
import type { Location } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { LocationForm, type LocationFormValues } from './LocationForm';

export type LocationAddModalProps = ModalProps & {
    title?: string;
    data?: Location;
};

export const LocationAddModal = ({
    title = 'New Location',
    data,
    onOk,
    ...props
}: LocationAddModalProps) => {
    const { addLocation } = useLocationActions();
    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    const handleSubmit = (values: LocationFormValues & { channel_id: string }) => {
        addLocation.mutate(values, {
            onSuccess: () => {
                if (onOk) {
                    onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                }
            },
        });
    };

    return (
        <StyledModal title={title} width={680} footer={null} {...props}>
            <LocationForm
                id="location-add"
                data={data}
                isEdit={false}
                onCancel={props.onCancel}
                loading={addLocation.isPending}
                onSubmit={handleSubmit}
            />
        </StyledModal>
    );
};
